/*
 * @Author: Teemo Ding
 * @Date: 2021-10-19 14:33:40
 * @LastEditTime: 2022-06-10 14:03:04
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/MiniProgramVersionRelease/index.tsx
 */
import { Alert, SizeFittingTable } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { getSalesChannelTimezoneGmt } from '@/src/constrains/SalesChannelHOC/slice';
import { Icon } from '@/src/tools/icon';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { releaseColumns } from '../config';
import css from '../css.module.less';
const MiniProgramVersionRelease = ({ releases }) => {
  const timezoneGmt = useSelector(getSalesChannelTimezoneGmt());

  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);

  //TODO Alert处理（需要字段）
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.logoWrapper}
      titleOnClick={() => setFold(!fold)}
      hideContent={!fold}
      title={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramVersionRelease',
      )}
      subtitle={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramVersionReleaseSubtitle',
      )}
      rightPart={<Icon type={fold ? 'icondown1' : 'iconright'}></Icon>}>
      <Alert
        className={css.certificateAlert}
        closable={true}
        message={getI18n(
          'salesChannelMiniProgramSettings.index.newReleaseRequired',
        )}
        showIcon
        type='error'
        icon={<Icon type='iconfailed'></Icon>}
        description={getI18n(
          'salesChannelMiniProgramSettings.index.newReleaseRequiredTips',
        )}
      />
      <h3>
        {getI18n('salesChannelMiniProgramSettings.index.releasedCodeVersion')}
      </h3>
      <SizeFittingTable
        rowKey='uuid'
        pagination={false}
        id='codeVersionPreview'
        columns={releaseColumns(timezoneGmt, { getI18n })}
        dataSource={releases}
        rowSelection={false}
      />
    </SectionWrapper>
  );
};
export default MiniProgramVersionRelease;
